module.exports = __webpack_public_path__ + "media/images/emblems/Muehleberg-coat_of_arms-518a4c1333d49856eded732a271cbba4.svg";